import { Theme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import React from "react"
import Grid from "@material-ui/core/Grid"
import CalendarDateLabel from "./CalendarDateLabel"
import CalendarContent from "./CalendarContent"
import CalendarTool from "./CalendarTool"
import Modal from "./Modal"
const useStyle = makeStyles((theme: Theme) => ({
    root: {
        marginTop: theme.spacing(4),
        color: theme.palette.text.secondary,
    },
}))

const Calendar = () => {
    const classes = useStyle()
    return (
        <Grid container className={classes.root}>
            <CalendarDateLabel />
            <CalendarContent />
            <CalendarTool />
            <Modal />
        </Grid>
    )
}

export default Calendar
